import { object, string, number, boolean, ValidationError } from "yup";
import * as Sentry from "@sentry/react";
import { parse } from "tldts";

export const MonitoringCreateFormSchema = object({
  domain: string()
    .transform((value, original) => {
      try {
        const stripped = (value as string).trim();
        try {
          const url = new URL(stripped);
          return url.hostname;
        } catch (e) {
          Sentry.captureException(e);
          return stripped;
        }
      } catch (e) {
        Sentry.captureException(e);
        return value;
      }
    })
    .test(
      "domain",
      "Enter a valid domain name (e.g. example.com)",
      function (value) {
        if (!value) {
          return false;
        }

        return parse(value)?.domain != null;
      }
    )
    .required(),
  profile_id: string().nullable(),
  external_ref_id: string().nullable(),
  closure_selected: boolean().required(),
  frequency_days: number().required(),
  content_selected: boolean().required(),
  sentiment_selected: boolean().required(),
  profile_selected: boolean().required(),
  connected_entities_selected: boolean().required(),
  people_selected: boolean().required(),
}).test("monitor_selection", "Please select at least one", (obj) => {
  const nothingSelected =
    !obj.closure_selected &&
    !obj.content_selected &&
    !obj.sentiment_selected &&
    !obj.connected_entities_selected &&
    !obj.people_selected &&
    !obj.profile_selected;
  if (nothingSelected) {
    return new ValidationError(
      "Please select at least one",
      undefined,
      "monitor_selection"
    );
  }
  return true;
});
